import { Controller } from "@hotwired/stimulus"

// CONEK-7120 — the desktop pairing surface is a modal on desktop and a plain
// page on mobile. The gateway index/show "Pair" buttons target the
// `pairing_modal` Turbo Frame (the desktop chrome); at narrow viewports the
// same click must be a full-page navigation instead, because the response's
// chrome is chosen server-side by the Turbo-Frame request header:
//
//   * fetched INTO the frame (header present) → modal-in-frame
//   * full-page fetch (header absent)        → plain page, no modal chrome
//
// On a click at ≤639px (Tailwind's sm breakpoint), delete the frame targeting
// BEFORE Turbo Drive's document-level click interceptor reads the attribute —
// element-level click listeners run before document-level ones in the bubble
// phase — so the navigation becomes a normal Turbo Drive visit and the server
// renders the plain page. Restart links need no such handling: inside the
// modal they navigate the frame (modal re-render), on the mobile page they
// full-navigate (page re-render).
//
// The removal is per-click, not permanent: the frame name is captured on
// connect and restored whenever the click happens above the breakpoint, so a
// mobile click followed by a resize (or a rotate) still opens the modal on
// the next click rather than full-navigating until a reload.
export default class extends Controller {
  connect() {
    this.frame = this.element.getAttribute("data-turbo-frame")
    // Turbo snapshots the page when navigating away — which, on the mobile
    // path, is immediately after the click stripped the attribute. Restore it
    // before the snapshot is taken so a cached restore (back button) never
    // brings back a button that has lost its frame target for good.
    this.restore = () => this.#restoreFrame()
    document.addEventListener("turbo:before-cache", this.restore)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.restore)
  }

  click() {
    if (window.matchMedia("(max-width: 639px)").matches) {
      this.element.removeAttribute("data-turbo-frame")
    } else {
      this.#restoreFrame()
    }
  }

  #restoreFrame() {
    if (this.frame) this.element.setAttribute("data-turbo-frame", this.frame)
  }
}
